<script setup>
    import { ref, computed, reactive, inject } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { getPrettyPrice, getCashPrice, getCardPrice, hashCode} from '../shared/utils';
    import useCartStore from '../store/cart';
    import { useProductStore } from '../store/products'
    import iconPlus from '@client/svg/plus.svg?raw';
    import iconMinus from '@client/svg/minus.svg?raw';

    // popup close
    const emit = defineEmits(['close']);

    // Component Props
    const props = defineProps({
        item: Object
    })

    let rootData = inject('rootData');
    const { t } = useI18n();

    const productStore = useProductStore()
    
    // Get data from props and store
    let image = props.item?.img ? props.item.img.medium_large : null;
    let price = parseInt(props.item.price, 10) > 0 ? parseInt(props.item.price, 10) : 0;
    let modifierGroupIds = props.item.modifierGroupIds.length > 0  ? props.item.modifierGroupIds : [];
    let modifierGroups = [];
    
    // Define product modifiers in groups for current instance
    modifierGroupIds.forEach(mgrId => {
        if (productStore.modifierGroups.hasOwnProperty(mgrId)) {
            let mgrp = Object.assign({}, productStore.modifierGroups[mgrId])
            let mods = {}
            mgrp.modifiers.forEach(mId => {
                if (productStore.modifiers.hasOwnProperty(mId)) {
                    mods[mId] = productStore.modifiers[mId];
                }
            })
            mgrp.modifiers = mods;
            modifierGroups.push( mgrp );
        }
    });

    // object-array for checked modifiers
    const checkedModifiers = reactive({});
    // set initial state - empty modifiers
    modifierGroups.forEach(modifierGroup => {
        checkedModifiers[modifierGroup.id] = []
    })

    // Product Note
    const noteField = ref(null);
    
    const add2orderBtn = ref(null);
    // Increase Quantity for Cart
    const quantity = ref(1);
    function increment() {
        if (quantity.value < 100)
        quantity.value++;
    }
    // Decrease Quantity for Cart
    function decrement() {
        if (quantity.value > 1)
        quantity.value--;
    }

    // calculate product price + modifiers price and quantity multiplication
    let calculatedTotalValue = computed({
        get(){
            let outputValue = price;
            for (const [key, value] of Object.entries(checkedModifiers)) {
                // checkbox modifiers
                if ( Array.isArray( value ) ) {
                    value.forEach(modifier => {
                        if (modifier?.price) {
                            outputValue += parseInt(modifier.price, 10)
                        }
                    })
                // radio modifiers
                } else if (value?.price) {
                    outputValue += parseInt(value.price, 10)
                }
            }
            return outputValue
        }
    });

    // price for output (with no modifications)
    let totalPrice = computed(()=> ( calculatedTotalValue.value * quantity.value ) );

    let isAcceptable = computed(() => {
        let result = true;
        modifierGroups.forEach(modifierGroup => {
            let checkedGroup = checkedModifiers[modifierGroup.id];
            // radio button expected
            if (modifierGroup.minRequired == 1 && modifierGroup.maxAllowed == 1) {
                if ( Array.isArray( checkedGroup ) ) {
                    console.log('error,radio button for %s not selected', modifierGroup.id)
                    result = false;
                } else {
                    console.log('radio buttons works fine');
                }
            } else if ( Array.isArray( checkedGroup ) && (
                ( modifierGroup.maxAllowed > 0 && checkedGroup.length > modifierGroup.maxAllowed ) || ( modifierGroup.minRequired > 0 && checkedGroup.length < modifierGroup.minRequired) )
            ) {
                console.log('error, expected %s <= %s <= %s checkboxes', modifierGroup.minRequired, checkedGroup.length, modifierGroup.maxAllowed)
                result = false;
            } else {
                console.log('checkboxes works fine');
            }
        });
        // console.log('all fine, true')
        return result;
    });
     
     
    //  {
    //     get(){
            // for (const [key, value] of Object.entries(checkedModifiers)) {
            //     let modifierGroup = null;
            //     modifierGroups.forEach(mgr => {
            //         if (mgr.id == key) {
            //             modifierGroup = mgr;
            //         }
            //     });
            //     if (modifierGroup) {
            //         if (modifierGroup.minRequired == 1 && modifierGroup.maxAllowed == 1) {
            //             if (
            //                 ( Array.isArray( value ) && value.length != 1 ) ||
            //                 ( !Array.isArray( value ) && typeof value === 'object' && !value)
            //             ) {
            //                     console.log('error,radio not selected')
            //                     return false;
            //             }
            //         }
            //         if ( Array.isArray( value ) & (
            //             ( modifierGroup.maxAllowed > 0 && value.length > modifierGroup.maxAllowed ) ||
            //             ( modifierGroup.minRequired > 0 && value.length < modifierGroup.minRequired) ) ) {
            //             return false;
            //         }
            //     }
            //  }
            //  return true;

                    // if ( Array.isArray( value ) ) {
                    // // radio modifiers
                    // } else if (!Array.isArray( value ) && typeof value === 'object') {
    
                    //     // console.log(modifierGroups[key].minRequired, modifierGroups[key].maxAllowed);
                    //     // console.log(key)
                    // }
                    // }
                // }

            // modifierGroups.forEach(modifierGroup => {
            //     let checkedGroup = checkedModifiers[modifierGroup.id];
            //     // radio button expected
            //     if (modifierGroup.minRequired == 1 && modifierGroup.maxAllowed == 1) {
            //         if ( Array.isArray( checkedGroup ) ) {
            //             console.log('error,radio button for %s not selected', modifierGroup.id)
            //             return false;
            //         } else {
            //             console.log('radio buttons works fine');
            //         }
            //     } else if ( Array.isArray( checkedGroup ) && (
            //         ( modifierGroup.maxAllowed > 0 && checkedGroup.length > modifierGroup.maxAllowed ) || ( modifierGroup.minRequired > 0 && checkedGroup.length < modifierGroup.minRequired) )
            //     ) {
            //         console.log('error, expected %s <= %s <= %s checkboxes', modifierGroup.minRequired, checkedGroup.length, modifierGroup.maxAllowed)
            //         return false;
            //     } else {
            //         console.log('checkboxes works fine');
            //     }
            // });
            // console.log('all fine, true')

            // modifierGroups.forEach(modifierGroup => {
            //     // console.log(checkedModifiers[modifierGroup.id]);
            //     let checkedGroup = checkedModifiers[modifierGroup.id];
            //     if (modifierGroup.minRequired == 1 && modifierGroup.maxAllowed == 1) {
            //         if (
            //             ( Array.isArray( checkedGroup ) && checkedGroup.length != 1 ) ||
            //             ( !Array.isArray( checkedGroup ) && typeof checkedGroup === 'object' && !checkedGroup)
            //            ) {
            //                 console.log('error,radio not selected')
            //                 return false;
            //             }
            //         } else if (
            //                     ( modifierGroup.maxAllowed > 0 && checkedGroup.length > modifierGroup.maxAllowed ) ||
            //                     ( modifierGroup.minRequired > 0 && checkedGroup.length < modifierGroup.minRequired) ){
            //                 return false;
            //         }
            // });
    //         return true;
    //     }
    // });
    const createLineItem = function(){
        // this modifications assigned to line item later
        let modifications = [];
        // this UUID - custom and used for detect repeated lineItems in cart
        let modifiersUUID = [];
        // create modifications object from checked modifiers in every modifierGroup
        modifierGroups.forEach(modifierGroup => {
            // if checkboxes - checked modgroup is array of checked modifiers
            if (Array.isArray( checkedModifiers[modifierGroup.id] )) {

                checkedModifiers[modifierGroup.id].forEach(modifier => {
                    let modification = {
                        "id": modifier.id,
                        "name": modifier.name,
                        "amount": parseInt(modifier.price, 10),
                        "modifier": {
                            "id": modifier.id,
                            "name": modifier.name,
                            "price": parseInt(modifier.price, 10),
                            "available": modifier.available,
                            "modifierGroup": {
                                "id" : modifier.groupId,  
                            }
                        }
                    }
                    modifications.push(modification);
                    modifiersUUID.push(modifierGroup.id + '=' + modifier.id);
                })

            // if radio button - checked modgroup is modifier object itself
            } else if (checkedModifiers[modifierGroup.id]?.id) {
                let modifier = checkedModifiers[modifierGroup.id];
                let modification = {
                    "id": modifier.id,
                    "name": modifier.name,
                    "amount": parseInt(modifier.price, 10),
                    "modifier": {
                        "id": modifier.id,
                        "name": modifier.name,
                        "price": parseInt(modifier.price, 10),
                        "available": modifier.available,
                        "modifierGroup": {
                            "id" : modifier.groupId,  
                        }
                    }
                }
                modifications.push(modification);
                modifiersUUID.push(modifierGroup.id + '=' + checkedModifiers[modifierGroup.id].id);
            }
        });

        let lineItemUUID = props.item.id + (modifiersUUID.length > 0 ? ':' + modifiersUUID.join(",") : '');
        let lineItemUUIDHash = hashCode(lineItemUUID, 0, true);

        const lineItem = {
            // "id": '',                   // stub
            "item": {
                "id" : props.item.id,
            },
            "name": props.item.name,
            "price": price,
            "unitQty": quantity.value ? quantity.value : 1,
            "note": String(noteField.value?.value),
            "modifications": modifications,
            "priceWithModifiers": calculatedTotalValue.value,
            "createdTime": Math.floor(Date.now() / 1000),
            "printed": true,
            "_uuid": lineItemUUID,
            "_uuidhash": lineItemUUIDHash,
        }

        // console.log(lineItem);
        useCartStore().add( lineItem );
        emit('close');
    }
</script>

<template>

    <div data-id="item.id" class="ezcl-item-modal">

        <div v-if="image" class="ezcl-item-modal__thumb">
            <img class="bg" :src="image" :alt="item.name" loading="lazy">
        </div>

        <div class="modal__header">
            <div class="ezcl-item-modal__name">{{ item.name }}</div>
        </div>

        <section class="modal__body">
            <div class="ezcl-item-modal__container">

                <div v-if="item.desc" class="ezcl-item-modal__desc">
                    {{ item.desc }}
                </div>

                <template v-if="modifierGroups">
                    <fieldset v-for="modifierGroup in modifierGroups" role="group" class="ezcl-mod__group">
                        <div class="ezcl-mod__legend">
                            <legend :data-min="modifierGroup?.minRequired" :data-max="modifierGroup?.maxAllowed">{{ modifierGroup.name }}</legend>
                            <div class="note" v-if="!(modifierGroup?.minRequired == 1 && modifierGroup?.maxAllowed == 1) && (modifierGroup?.minRequired > 0 || modifierGroup?.maxAllowed > 0)">
                                <div v-if="modifierGroup?.minRequired > 0 && modifierGroup?.maxAllowed > 0" :class="{'required': (checkedModifiers[modifierGroup.id].length < modifierGroup?.minRequired) || (checkedModifiers[modifierGroup.id].length > modifierGroup?.maxAllowed)}">
                                    {{ t('item.minRequiredMaxAllowed', { min: modifierGroup?.minRequired, max: modifierGroup?.maxAllowed }) }}
                                </div>
                                <div v-else-if="modifierGroup?.minRequired > 0 && modifierGroup?.maxAllowed == 0" :class="{'required': checkedModifiers[modifierGroup.id].length < modifierGroup?.minRequired}">
                                    {{ t('item.requiredMinOrMore', { min: modifierGroup?.minRequired }) }}
                                </div>
                                <div v-else-if="modifierGroup?.minRequired == 0 && modifierGroup?.maxAllowed > 0" :class="{'required': checkedModifiers[modifierGroup.id].length > modifierGroup?.maxAllowed}">
                                    {{ t('item.maxAllowed', { max: modifierGroup?.maxAllowed }) }}
                                </div>
                            </div>
                            <div class="note" v-else-if="(modifierGroup?.minRequired == 1 && modifierGroup?.maxAllowed == 1)">
                                <div :class="{'required': !checkedModifiers[modifierGroup.id]?.id}">
                                    {{ t('item.requiredSelectOne') }}
                                </div>
                            </div>
                            <div class="note optional" v-else v-text="t('item.optional')"></div>
                        </div>

                        <div v-for="modifier in modifierGroup.modifiers" class="ezcl-mod__row">

                            <label v-if="modifier.available" class="ezcl-mod__input">
                                <input v-if="modifierGroup?.minRequired == 1 && modifierGroup?.maxAllowed == 1"
                                    type="radio"
                                    :name="modifierGroup.id"
                                    :value="modifier"
                                    v-model="checkedModifiers[modifierGroup.id]">
                                <input v-else
                                    type="checkbox"
                                    :name="modifierGroup.id"
                                    :value="modifier"
                                    :disabled="modifierGroup?.maxAllowed >= 1 && checkedModifiers[modifierGroup.id].length >= modifierGroup.maxAllowed && checkedModifiers[modifierGroup.id].indexOf(modifier) == -1"
                                    v-model="checkedModifiers[modifierGroup.id]"
                                >
                                <span aria-hidden="true"></span>
                                <span class="ezcl-mod__name">{{ modifier.name }}</span>
                                <span v-if="parseInt(modifier.price, 10) > 0" :id="modifier.id + '-price'" class="ezcl-mod__price">
                                    <template v-if="rootData.dualpricing">
                                        <div v-text="getPrettyPrice(getCardPrice(parseInt(modifier.price, 10)))"></div>
                                        <div v-text="getPrettyPrice(getCashPrice(parseInt(modifier.price, 10)))"></div>
                                    </template>
                                    <template v-else>
                                        <div v-text="getPrettyPrice(parseInt(modifier.price, 10))"></div>
                                    </template>
                                </span>
                            </label>

                        </div>
                    </fieldset>
                </template>
            </div>
            <div class="ezcl-item-modal__container">
                <div class="instructions" v-show="!rootData?.ordering?.catalog">
                    <textarea name="product-special-instructions" rows="3" :placeholder="t('item.instructionsPlaceholder')" ref="noteField" maxlength="255"></textarea>
                    <label for="product-special-instructions">{{ t('item.specialInstructions') }}</label>
                </div>
            </div>
        </section>

        <footer class="modal__footer" v-show="!rootData?.ordering?.catalog">
            <div class="ezcl-item-modal__total">
                <div class="counter">
                    <button @click="decrement" class="counter__dec primary" :disabled="quantity <= 1">
                        <div v-html="iconMinus"></div>
                    </button>

                    <div class="counter__value">{{ quantity }}</div>
                    <button @click="increment" class="counter__inc primary" :disabled="quantity >= 99">
                        <div v-html="iconPlus"></div>
                    </button>
                </div>

                <button :disabled="!isAcceptable" class="btn btn-add2order primary" ref="add2orderBtn" @click="createLineItem()">
                    <span>{{ t('item.addToOrder') }}</span>
                    <div v-show="calculatedTotalValue > 0" class="ezcl-item-modal__subtotal">
                        <template v-if="rootData.dualpricing">
                            <div v-text="getPrettyPrice(getCardPrice(totalPrice))"></div>
                            <div v-text="getPrettyPrice(getCashPrice(totalPrice))"></div>
                        </template>
                        <template v-else>
                            <div v-text="getPrettyPrice(totalPrice)"></div>
                        </template>
                    </div>
                </button>
            </div>
        </footer>

    </div>
</template>

<style lang="scss" scope>
.modal {
    &__header {
        align-items: center;
        border-radius: 0.25rem 0.25rem 0 0;
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 0;
        padding: 1rem 0.5rem 1rem 1rem;
        z-index: 1;
        background: linear-gradient(#fff, #fff 95%, rgba(255, 255, 255, 0));
        background-color: #ffffff;
        border-bottom: 1px solid #dee2e6;
        box-shadow: 0 .125rem .25rem rgba(0,0,0,.075) !important;

        &--inner {
            padding-right: 0.5rem;
        }
    }
    &__body {
        padding: 1rem;
        background-color: #ffffff;
        overflow-y: auto;
        flex: 1 1 auto;
    }
    &__footer {
        margin-top: auto;
        position: sticky;
        z-index: 1;
        bottom: 0;
        background-color: #f5f3f0;
        // background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff 5%,#fff);
        // box-shadow: 0 -.125rem .25rem rgba(0,0,0,.075);
        // border-top: 1px solid #dee2e6;
    }
    &__header,
    &__body,
    &__footer {
        width: 100%;
    }
    &__close {
        float: right;
        margin: 1rem;
        padding: 5px;
        position: fixed;
        right: 0;
        z-index: 10;
        border: none;
    }
}
.ezcl-item-modal {
    $name: &;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (min-width: 1280px) {
        min-height: 540px;
        min-height: 100%;
    }

    &__thumb {
        height: 375px;
        position: relative;
        border-radius: .25rem .25rem 0 0;
        overflow: hidden;
        background: #fff;
        
        ~ .modal__header {
            border-radius: 0;
        }
    }
    &__desc {
        font-weight: 400;
        margin-bottom: 1.5rem;
        font-size: 0.875rem;
        color: #201e1e;
    }
    &__name {
        position: sticky;
        display: flex;
        align-items: center;
        justify-content: space-between;
        top: 0;
        text-align: left;
        font-weight: 700;
    }

    &__subtotal {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex: 0 0 auto;

        div {
            position: relative;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex: 0 0 auto;
            line-height: 1.375;
            // margin-top: 1.25rem;
            padding-right: .375rem;
            padding-left: .375rem;
            min-width: 6ch;
            
            &:first-child::after {
                content: "";
                width: 1px;
                background-color: #ffffff;
                position: absolute;
                opacity: 0.75;
                right: 0;
                transform-origin: center;
                top: 0;
                // height: 100%;
                // transform: translate3d(-50%,-1px,0);
                transform: translate3d(-50%, 3px, 0);
                height: 1rem;
                line-height: 1;
            }
        }
    }
    &__total {
        display: flex;
        flex-direction: column;
        border-radius: 0 0 .25rem .25rem;
        // justify-content: space-between;

        @media (min-width: 576px) {
            flex-direction: row;
        }

        .btn-add2order {
            flex: 1 1 100%;

            @media (min-width: 576px) {
                flex: 1 1 auto;
            }

            div {
                line-height: 1;
            }
        }

        .btn.btn-add2order {
            display: flex;
            justify-content: space-between;
            margin: 0;
            font-size: 1.25rem;
            font-size: 1rem;
            font-weight: 600;
            padding: 1rem;

            &:disabled {
                opacity: 0.5;
                background-color: #9b9b9b;
            }
        }
    }
}
.counter {
    flex: 1 1 100%;
    display: flex;
    justify-content: space-between;

    &__value,
    &__dec,
    &__inc {
        justify-content: center;
        align-items: center;
        display: flex;
        flex: 1 1 auto;
        text-align: center;
        font-weight: 700;
        user-select: none;
        font-size: 1.25rem;
        padding: 1rem;
    }
    
    &__value {
        flex: 1 0 48px;
        line-height: 1;
        height: 48px;
    }

    &__inc,
    &__dec {
        height: 48px;
        width: 48px;
        flex: 0 1 48px;

        &[disabled] {
            color: #727272;
            background: #ffffff;
            // opacity: 0.1;
        }
    }
    @media (min-width: 576px) {
        flex: 0 1 144px;
    }
}

.ezcl-mod {
    $name: &;

    &__legend {
        color: #5c5c5c;
        font-size: .875rem;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.5rem;

        legend {
            font-weight: 600;
        }
        .note {
            font-size: .75rem;
            margin-bottom: 0.5rem;
            transition: color .5s ease;
            opacity: 0.75;
            letter-spacing: -0.25px;

            .required {
                color: #e70000;
                transform: translateZ(0);
                transition: opacity 0.33s 0s linear;
                animation: wiggle 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                transform: translate3d(0, 0, 0);
                backface-visibility: hidden;
            }
        }

    }
    &__group {
        margin-bottom: 1rem;
        border: none;
        padding: 0;
        padding-bottom: 0.5rem;
        // border-bottom: 1px solid #e7e9ed;
        
        // &:last-child {
        //     border-bottom: none;
        //     padding-bottom: 0;
        //     margin-bottom: 0;
        // }
    }
    &__row {
        align-items: center;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;

        // &:not(:last-child) {
        // }
    }
    &__name{
        padding-left: calc(22px + .5em);
        line-height: 1.375;
    }
    &__input {
        color: #1d1d1d;
        font-weight: 400;
        letter-spacing: -0.25px;

        padding: 0.6875rem 0;
        width: 100%;
        display: flex;
        margin: 0;
        position: relative;

        input {
            clip: rect(0,0,0,0);
            position: absolute;

            & + span {
                border-radius: 3px;
                border: 2px solid #c7c7c7;
                height: 22px;
                left: 0;
                position: absolute;
                width: 22px;
            }
            &[type="radio"] {
                & + span {
                    border-radius: 50%;
                }
                &:checked + span {
                    background-color: #fff;
                    border: 7px solid var(--c-primary);
                    animation: ripple 0.2s linear forwards;
                }
            }

            &[type="checkbox"] {
                &:checked + span {
                    background-color: var(--c-primary);
                    border: 1px solid var(--c-primary);
                    animation: ripple 0.2s linear forwards;


                    &::after {
                        border: solid #fff;
                        border-width: 0 2px 2px 0;
                        content: "";
                        height: 10px;
                        left: 8px;
                        position: absolute;
                        top: 4px;
                        -webkit-transform: rotate(45deg);
                        transform: rotate(45deg);
                        width: 5px;
                    }
                }
            }

            &[disabled] {
                & ~ #{$name}__name {
                    pointer-events: none;
                    color: #c7c7c7;
                }
            }
        }
    }
    &__price {
        color: #727272;
        padding-left: 16px;
        margin-left: auto;
        font-size: var(--font-size-sm);
        font-weight: 400;
        display: flex;
        justify-content: flex-end;
        align-self: start;
        
        div {
            position: relative;
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex: 0 0 auto;
            line-height: 1.375;
            // margin-top: 1.25rem;
            padding-right: .375rem;
            padding-left: .375rem;
            min-width: 6ch;

            &:first-child::after {
                content: "";
                width: 1px;
                background-color: var(--menu-separator-color);
                position: absolute;
                opacity: 0.75;
                right: 0;
                transform-origin: center;
                top: 0;
                // height: 100%;
                // transform: translate3d(-50%,-1px,0);
                transform: translate3d(-50%, 3px, 0);
                height: 1rem;
            }
        }
    }
}

.instructions {
    position: relative;
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.15s 0s linear;
    max-height: 111px;

    textarea {
        line-height: 1.5;
        padding: 26px 8px 8px;
        border: 1px solid #727272;
        border-radius: 0.25rem;
        outline: none;
        margin-bottom: 0;
    }

    label {
        color: #727272;
        font-size: .8rem;
        left: 1px;
        line-height: 1;
        margin: 8px;
        padding: 0;
        position: absolute;
        top: 1px;
        transition: font-size .2s ease;
        font-weight: 500;
    }
}


@keyframes ripple {
  0% {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0);
  }

  50% {
    box-shadow: 0 0 0 0.5rem rgba(0, 0, 0, 0.1);
  }

  100% {
    box-shadow: 0 0 0 0.5rem rgba(0, 0, 0, 0);
  }
}

@keyframes wiggle {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>